"use strict";

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var apollo_boost_1 = require("apollo-boost");

var apollo_link_1 = require("apollo-link");

var apollo_link_http_1 = require("apollo-link-http");

var apollo_link_ws_1 = require("apollo-link-ws");

var apollo_utilities_1 = require("apollo-utilities");

var eth_sdk_1 = require("eth-sdk");

var AbstractGraphQLClient = /*#__PURE__*/function () {
  function AbstractGraphQLClient(options, connectionOptions) {
    _classCallCheck(this, AbstractGraphQLClient);

    options = Object.assign({
      host: 'localhost',
      port: null,
      useSsl: false
    }, options);
    var fetch = connectionOptions.fetch,
        webSocketImpl = connectionOptions.WebSocket;
    var httpLink = new apollo_link_http_1.HttpLink({
      fetch: fetch,
      uri: AbstractGraphQLClient.buildUri(options, 'http', 'graphql')
    });
    var wsLink = new apollo_link_ws_1.WebSocketLink({
      webSocketImpl: webSocketImpl,
      uri: AbstractGraphQLClient.buildUri(options, 'ws', 'ws'),
      options: {
        reconnect: true
      }
    });
    var link = apollo_link_1.split( // split based on operation type
    function (_ref) {
      var query = _ref.query;
      var definition = apollo_utilities_1.getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    }, wsLink, httpLink);
    link = apollo_link_1.from([link]);
    this.apolloClient = new apollo_boost_1.ApolloClient({
      link: link,
      cache: new apollo_boost_1.InMemoryCache({
        resultCaching: false
      })
    });
  }

  _createClass(AbstractGraphQLClient, [{
    key: "query",
    value: function query(_query) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.apolloClient.query({
        query: _query,
        variables: AbstractGraphQLClient.prepareVariables(variables),
        fetchPolicy: 'no-cache'
      }).then(function (_ref2) {
        var output = _ref2.data.output;
        return AbstractGraphQLClient.prepareOutput(output);
      });
    }
  }, {
    key: "mutate",
    value: function mutate(mutation) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.apolloClient.mutate({
        mutation: mutation,
        variables: AbstractGraphQLClient.prepareVariables(variables)
      }).then(function (_ref3) {
        var output = _ref3.data.output;
        return AbstractGraphQLClient.prepareOutput(output);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(query) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.apolloClient.subscribe({
        query: query,
        variables: AbstractGraphQLClient.prepareVariables(variables)
      }).map(function (_ref4) {
        var output = _ref4.data.output;
        return AbstractGraphQLClient.prepareOutput(output);
      });
    }
  }], [{
    key: "buildUri",
    value: function buildUri(options, protocol, path) {
      var useSsl = options.useSsl,
          host = options.host,
          port = options.port;
      return "".concat(protocol).concat(useSsl ? 's' : '', "://").concat(host).concat(port ? ":".concat(port) : '', "/").concat(path);
    }
  }, {
    key: "prepareVariables",
    value: function prepareVariables(variables) {
      var keys = Object.keys(variables);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        var value = variables[key];

        if (bn_js_1.default.isBN(value)) {
          variables[key] = eth_sdk_1.toHex(value);
        }
      }

      return variables;
    }
  }, {
    key: "prepareOutput",
    value: function prepareOutput(output) {
      var result;

      if (output && typeof output === 'object') {
        var keys = Object.keys(output).filter(function (key) {
          return !key.startsWith('_');
        });
        result = {};

        var _iterator = _createForOfIteratorHelper(keys),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            result[key] = AbstractGraphQLClient.prepareOutput(output[key]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        result = output;
      }

      return result;
    }
  }]);

  return AbstractGraphQLClient;
}();

exports.AbstractGraphQLClient = AbstractGraphQLClient;